import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTES } from '_/constants/routes'

// The reports moved into the overview as tabs. Kept as a redirect so bookmarks
// and old links land on the spend report rather than a 404.
export const Route = createFileRoute('/_authenticated/finance/reports')({
	staticData: { title: 'reports_title' },
	beforeLoad: () => {
		throw redirect({ href: ROUTES.finance.reports })
	},
})
